import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="email-templates"
export default class extends Controller {
  static targets = ["templateSelect", "subjectField", "contentField"]

  connect() {
  }

  selectTemplate(event) {
    const emailTemplateId = event.target.value;
    const subjectTemplate = document.getElementById('email_template_subject_' + emailTemplateId);
    const contentTemplate = document.getElementById('email_template_content_' + emailTemplateId);
    const subjectField = document.getElementById('outbound_email_subject');
    const contentField = document.getElementById('outbound_email_content');

    if (subjectTemplate && subjectField) {
      subjectField.value = subjectTemplate.innerHTML.trim();
    }
    if (contentTemplate && contentField) {
      let content = contentTemplate.innerHTML.trim().replace(/&gt;/g, ">").replace(/&lt;/g, "<");

      const rhinoEditor = document.querySelector("rhino-editor");
      const editor = rhinoEditor.editor;
      editor.commands.setContent(content);
      editor.commands.focus();
    }
  }
}
